import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class EmployeedetailsService {
  
  private apiurl = CONFIGURATION.baseServiceUrl + 'employee-search/';
  private _filemannagementUrl = CONFIGURATION.basefile1094CURL;
  constructor(private _http: Http) { }


  get1095PDF(id: number,address:boolean) {
    const headers = new Headers();
    headers.append('Client-Id', 'HIC-REPORTING-API-CLIENT');
    headers.append('Client-Secret', 'f65ce994-e74e-11e7-80c1-9a214cf093ae');
    return this._http.get(this._filemannagementUrl + `1095c/generatePdfById?id=${id}&address=${address}`, {headers: headers, responseType: ResponseContentType.Blob})
      .map((res: Response) => {
        return new Blob([res.blob()], { type: 'application/pdf' })
      });
  }
  
  excelDownload(data:any){
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');

    return this._http.post(`${this.apiurl}excel`,data, { headers: headers, responseType: ResponseContentType.Blob })
      .map((response: Response) => {
        return new Blob([response.blob()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      })
  }

  getReferenceData(data:any) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(`${this.apiurl}reference-data`, data, { headers: headers })
      .map((response: Response) => response.json())
  }
  
  getReportData(data:any) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(`${this.apiurl}report-data`, data, { headers: headers })
      .map((response: Response) => response.json())
  }

}


// WEBPACK FOOTER //
// ./src/app/employeedetails/employeedetails.service.ts